import { Page } from 'www-cms';

export namespace PageActions {
  export class SetPage {
    static readonly type = '[Page Resolver] Set page';
    constructor(public payload: Page) {}
  }
}
